import React from 'react';
import { LinkButton } from 'fronton-react';

type Props = {
  onClick: () => void;
};

export const CloseButton: React.FC<Props> = ({ onClick }) => (
  <LinkButton
    form="headersearchform"
    size="m"
    data-qa-header-search-clear=""
    data-qa="close-button"
    variant="normal"
    onClick={onClick}>
    Закрыть
  </LinkButton>
);
